module.exports = __webpack_public_path__ + "static/img/preview-02.e059a34c.webp";